<template>
  <v-app id="sandbox">
    <bmpag-toolbar></bmpag-toolbar>

    <v-main class="page-background">
      <v-container fluid>
        <v-row>
          <v-col cols="12" >
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer absolute inset color="custom-footer" app class="d-flex justify-center align-center muli-regular paragraph" style="color: #808080;">
      <span class="py-1">&copy; {{ new Date().getFullYear() }} BMP Money Plus. Todos diretos reservados.</span>
    </v-footer>
  </v-app>
</template>

<script>
export default { }
</script>
